import styles from './BundleSummaryFeatures.scss';

import React from 'react';

import { BundleSummaryFeatureValue } from 'src/api/contentful/contentTypes.cloverdotcom';
import { Image } from 'src/components/Image/Image';
import checkIcon from 'src/images/icons/check.svg';
import { FlatEntry } from 'src/services/cms/flattenContentful';
import { ContentImage } from '../ContentImage/ContentImage';
import { TextV2 } from '../TextV2/TextV2';

interface BundleSummaryFeaturesProps {
  feature?: FlatEntry<BundleSummaryFeatureValue>;
}

export const BundleSummaryFeature: React.FC<BundleSummaryFeaturesProps> = ({ feature }) => {
  if (!feature) return null;

  return (
    <div className={styles.feature} role="listitem">
      <div className={styles.featureImageContainer}>
        {feature.image ? (
          <ContentImage
            entry={feature.image}
            className={styles.featureImage}
            aria-hidden="true"
          />
        ) : (
          <Image
            src={checkIcon}
            className={styles.featureImage}
            aria-hidden="true"
          />
        )}
      </div>
      <TextV2 value={feature.description} tagName="p" variant="body-small" className={styles.featureText} />
    </div>
  );
};

BundleSummaryFeature.displayName = 'BundleSummaryFeature';
